"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCompletionDialog = exports.EntityCompletionDialogDefaultProps = exports.ENTITY_COMPLETION_QUERY = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../elements/dialog");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var icon_button_1 = require("../elements/icon-button");
var use_modal_1 = require("../../hooks/use-modal");
var client_1 = require("@apollo/client");
var loader_1 = require("../elements/loader");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var sprintf_js_1 = require("sprintf-js");
var markdown_1 = require("../elements/markdown");
var lodash_1 = require("lodash");
// -------- Types -------->
exports.ENTITY_COMPLETION_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EntityCompletion($input: CompletionInput) {\n    completion(input: $input) {\n      text\n    }\n  }\n"], ["\n  query EntityCompletion($input: CompletionInput) {\n    completion(input: $input) {\n      text\n    }\n  }\n"])));
exports.EntityCompletionDialogDefaultProps = {
  fieldName: 'Description',
  onConfirm: function (entity) {
    console.log(entity);
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(1))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SuggestionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border: 4px dashed ", ";\n    background: ", ";\n    padding: ", ";\n    border-radius: 12px;\n  "], ["\n    border: 4px dashed ", ";\n    background: ", ";\n    padding: ", ";\n    border-radius: 12px;\n  "])), theme_1.theme.COLOR('line-sidebar'), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4))
});
var ButtonsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SuggestionAndRetryStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var NotRightStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", ";\n    padding-bottom: 0;\n  "], ["\n    font-size: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", ";\n    padding-bottom: 0;\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(3))
});
var RegenerateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    margin-left: ", ";\n  "], ["\n    ", ";\n    margin-left: ", ";\n  "])), ButtonStyles, theme_1.theme.UNIT(2))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", ";\n    padding-bottom: ", ";\n\n    strong {\n      font-size: ", ";\n      font-weight: 500;\n      color: #333;\n    }\n  "], ["\n    font-size: ", ";\n    padding-bottom: ", ";\n\n    strong {\n      font-size: ", ";\n      font-weight: 500;\n      color: #333;\n    }\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(15))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Body: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Intro: (0, styled_components_1.default)(markdown_1.Markdown)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  SuggestionAndRetry: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SuggestionAndRetryStyles),
  Suggestion: (0, styled_components_1.default)(markdown_1.Markdown)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), SuggestionStyles),
  NotRight: styled_components_1.default.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), NotRightStyles),
  Buttons: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  Button: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  RegenerateButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), RegenerateButtonStyles)
};
var EntityCompletionDialog = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    entityName = props.entityName,
    fieldName = props.fieldName,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var t = (0, use_lang_1.useLang)();
  var title = (0, sprintf_js_1.sprintf)(t("OpenAI %s for %s"), fieldName, entityName);
  var Icons = (0, use_icons_1.useIcons)();
  var modal = (0, use_modal_1.useModal)();
  var _a = __read((0, client_1.useLazyQuery)(exports.ENTITY_COMPLETION_QUERY, {
      variables: {
        input: {
          entityName: entityName,
          entityTypeName: entityTypeName
        }
      },
      fetchPolicy: 'network-only'
    }), 2),
    generate = _a[0],
    _b = _a[1],
    loading = _b.loading,
    _c = _b.data,
    data = _c === void 0 ? {
      completion: {
        text: ''
      }
    } : _c;
  (0, react_1.useEffect)(function () {
    generate();
  }, []);
  var text = (0, lodash_1.get)(data, 'completion.text', '');
  var button = react_1.default.createElement(My.Button, {
    disabled: loading,
    onClick: function () {
      onConfirm(text);
    },
    icon: react_1.default.createElement(Icons.TickCircle, null)
  }, (0, sprintf_js_1.sprintf)(t('Use This %s'), fieldName));
  return react_1.default.createElement(My.Dialog, {
    icon: Icons.OpenAI,
    title: title,
    onCancel: onCancel,
    showCancelButton: true,
    className: className,
    button: button
  }, react_1.default.createElement(My.Body, null, loading ? react_1.default.createElement(My.Loader, {
    spinnerSize: 24
  }, (0, sprintf_js_1.sprintf)(t('Generating %s via OpenAI. Please wait...'), fieldName)) : react_1.default.createElement(My.SuggestionAndRetry, null, react_1.default.createElement(My.Intro, {
    text: (0, sprintf_js_1.sprintf)(t("**Here is the %s OpenAI generated for the %s _%s_**. \n\nNote: this text is _generated_ via artificial intelligence models. While these models are generally quite accurate, they won't always generate the desired results and correctness should be verified based on your own knowledge."), fieldName.toLowerCase(), defn.label, entityName)
  }), react_1.default.createElement(My.Suggestion, {
    text: text
  }), react_1.default.createElement(My.NotRight, null, t('Not quite right?'), react_1.default.createElement(My.RegenerateButton, {
    onClick: function () {
      generate();
    },
    icon: react_1.default.createElement(Icons.OpenAIGenerate, null)
  }, t('Generate again'))))));
};
exports.EntityCompletionDialog = EntityCompletionDialog;
exports.EntityCompletionDialog.defaultProps = exports.EntityCompletionDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;